export default "__VITE_PUBLIC_ASSET__4efa4e69__"